import { theme } from "antd";
import { Config } from "tailwindcss";
import TailwindTheme from "tailwindcss/defaultTheme";

import { PrimaryTheme as AntDesignTheme } from "../ant-design";
import { SpecificationColors, SpecificationSize } from "../specification";

const tokens = theme.getDesignToken(AntDesignTheme);

/**
 * tailwind 配置
 */
export const TailwindConfig: Config = {
  content: ["./src/**/*.{ts,less,tsx}"],
  theme: {
    extend: {
      // antd 规范 token
      ant: {
        ...tokens,
        components: AntDesignTheme?.components,
      },
      // 规范颜色
      colors: {
        ...TailwindTheme.colors,
        // 规范颜色
        ...SpecificationColors,
      },
      // 规范尺寸
      size: {
        ...SpecificationSize,
      },
    },
  },
  plugins: [],
};
